<template>
    <div class="preparation-print-delivery-stickers-page">
        <transition name="loading-screen">
            <LoadingScreen v-if="loading" />
        </transition>
        <template v-if="errors">
            <ErrorsZone :errors="errors" />
        </template>
        <template v-if="loadedOnce && !errors && order">
            <div class="row mb-4 align-items-center">
                <div class="col-md-6 col-12">
                    <PreparationCustomerOrderCustomerInformation
                        :order="order"
                    />
                </div>
                <div class="col-md-6 col-12">
                    <OrderPreparationProgressBar
                        v-if="order.preparable"
                        :label="order.status_label"
                        :preparation-status="progressCounters"
                    />
                </div>
            </div>

            <div class="row mb-4">
                <div class="col-md-6 col-12 mx-auto alert alert-success">
                    <h3>Etiquettes</h3>
                    <div v-if="order.final_customer_type === 'customer_group'">
                        <div class="row mb-2">
                            <div class="col-12">
                                <a class="btn btn-outline-success btn-block"
                                   :href="`/espace-employes/commandes/preparation/commande/${order.id}/etiquettes`">
                                    <i class="fad fa-file-pdf fa-2x"></i>
                                    <br>
                                    Afficher<br>les étiquettes
                                </a>
                            </div>
                        </div>
                        <div class="row mb-2">
                            <div v-for="printer in printers" class="col-md-6 col-12 mb-2">
                                <a class="btn btn-success btn-block"
                                   @click="confirmPrint($event, 'Etiquettes', printer.name)"
                                   :href="`/espace-employes/commandes/preparation/commande/${order.id}/etiquettes/imprimer/${printer.id}`">
                                    <i class="fad fa-print fa-2x"></i>
                                    <br>
                                    Imprimer les étiquettes
                                    <br>
                                    {{ printer.name }}
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </template>
    </div>
</template>

<script>
    import ErrorsZone from "../ErrorsZone";
    import LoadingScreen from "../LoadingScreen";
    import OrderPreparationProgressBar from "./CustomerOrder/OrderPreparationProgressBar";
    import PreparationCustomerOrderCustomerInformation from "./PreparationCustomerOrderCustomerInformation";
    import {useGetLoader} from "../compositions/axios/loadingRequest";

    export default {
        name: 'PreparationPrintDeliveryStickersPage',

        components: {
            ErrorsZone,
            LoadingScreen,
            OrderPreparationProgressBar,
            PreparationCustomerOrderCustomerInformation,
        },

        props: {
            orderId: {
                type: String,
                required: true,
            },
            printers: {
                type: Array,
                required: true,
            },
        },

        setup() {
            const {
                loaded,
                loading,
                errors,
                load,
            } = useGetLoader();

            return {
                loaded,
                loading,
                errors,
                load,
            };
        },

        data() {
            return {
                order: null,
                progressCounters: {
                    nb_ordered: 0,
                    nb_prepared: 0,
                    nb_missing: 0,
                },
                loadedOnce: false,
                pickupPointsCounters: null,
            }
        },

        created() {
            Echo.private(`employees`)
                .listen('OrderUpdatedEvent', (e) => {
                    if (e.order.id == this.orderId) {
                        this.loadStateFromServer();
                    }
                });
        },

        async mounted() {
            this.loadStateFromServer();
        },

        methods: {
            async loadStateFromServer() {
                const data = await this.load(`/espace-employes/commandes/preparation/commande/${this.orderId}/json`);
                if (data) {
                    this.order = data.order;
                    this.progressCounters = data.progressCounters;
                    this.pickupPointsCounters = data.pickupPointsCounters;

                    this.loadedOnce = true;
                }
            },

            confirmPrint(event, documentName, printerName) {
                let message = 'Êtes vous sûr de vouloir lancer l\'impression du document '+documentName+' sur l\'imprimante '+printerName+' ?';
                if(!confirm(message)) {
                    event.preventDefault();
                }
            },
        },
    }
</script>
